import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { InvitePage } from '../invite/invite';
import { GroupViewPage } from '../group-view/group-view';

@Component({
  selector: 'page-group-permissions',
  templateUrl: 'group-permissions.html'
})
export class GroupPermissionsPage {
  // this tells the tabs component which Pages
  // should be each tab's root Page
  constructor(public navCtrl: NavController) {
  }
  goToInvite(params){
    if (!params) params = {};
    this.navCtrl.push(InvitePage);
  }goToGroupView(params){
    if (!params) params = {};
    this.navCtrl.push(GroupViewPage);
  }goToGroupPermissions(params){
    if (!params) params = {};
    this.navCtrl.push(GroupPermissionsPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/group-permissions/group-permissions.ts